import { GRID_NODE_TYPES } from './constants';
import shallowEqual from 'react-utils/shallowEqual';
export function computeAddedRemovedAndChangedNodes(idsOfSameTypeOnCurrentAndPreviousTrees, type, tree, prevTree) {
  const addedNodes = [];
  const removedNodes = [];
  const changedNodes = [];
  idsOfSameTypeOnCurrentAndPreviousTrees.forEach(nodeId => {
    // If there is no previous tree, we just assume that each node is new
    if (!prevTree) {
      const node = tree.findNode(nodeId);
      addedNodes.push(node.exportNode());
      return;
    }

    // If the node was added onto the tree
    if (!prevTree.hasNode(nodeId, type) && tree.hasNode(nodeId, type)) {
      const node = tree.findNode(nodeId);
      addedNodes.push(node.exportNode());
      return;
    }

    // If the node was removed from the tree
    if (prevTree.hasNode(nodeId, type) && !tree.hasNode(nodeId, type)) {
      const node = prevTree.findNode(nodeId);
      removedNodes.push(node.exportNode());
      return;
    }
    const node = tree.findNode(nodeId);
    const prevNode = prevTree.findNode(nodeId);
    if (
    // If the node value has changed
    node.getValue() !== prevNode.getValue() ||
    // If the node was moved to a new parent
    node.getParentNodeId() !== prevNode.getParentNodeId()) {
      changedNodes.push(node.exportNode());
      return;
    }
    if (
    // If the node is not a module
    !node.isModule() && !prevNode.isModule() &&
    // If the node has different children
    node.getChildNodeIds() !== prevNode.getChildNodeIds()) {
      changedNodes.push(node.exportNode());
      return;
    }
  });
  return {
    addedNodes,
    removedNodes,
    changedNodes
  };
}
export function computeGridLayoutTreeDiff(tree, prevTree) {
  var _prevTree$getSectionI, _prevTree$getModuleId, _prevTree$getContaine;
  const allSectionIds = tree.getSectionIds();
  const allContainerIds = tree.getContainerIds();
  const allModuleIds = tree.getModuleIds();
  const allPrevSectionIds = (_prevTree$getSectionI = prevTree === null || prevTree === void 0 ? void 0 : prevTree.getSectionIds()) !== null && _prevTree$getSectionI !== void 0 ? _prevTree$getSectionI : [];
  const allPrevModuleIds = (_prevTree$getModuleId = prevTree === null || prevTree === void 0 ? void 0 : prevTree.getModuleIds()) !== null && _prevTree$getModuleId !== void 0 ? _prevTree$getModuleId : [];
  const allPrevContainerIds = (_prevTree$getContaine = prevTree === null || prevTree === void 0 ? void 0 : prevTree.getContainerIds()) !== null && _prevTree$getContaine !== void 0 ? _prevTree$getContaine : [];
  const {
    addedNodes: addedSections,
    removedNodes: removedSections,
    changedNodes: changedSections
  } = computeAddedRemovedAndChangedNodes(new Set(allSectionIds.concat(allPrevSectionIds !== null && allPrevSectionIds !== void 0 ? allPrevSectionIds : [])), GRID_NODE_TYPES.SECTION, tree, prevTree);
  const {
    addedNodes: addedContainers,
    removedNodes: removedContainers,
    changedNodes: changedContainers
  } = computeAddedRemovedAndChangedNodes(new Set(allContainerIds.concat(allPrevContainerIds !== null && allPrevContainerIds !== void 0 ? allPrevContainerIds : [])), GRID_NODE_TYPES.CONTAINER, tree, prevTree);
  const {
    addedNodes: addedModules,
    removedNodes: removedModules,
    changedNodes: changedModules
  } = computeAddedRemovedAndChangedNodes(new Set(allModuleIds.concat(allPrevModuleIds !== null && allPrevModuleIds !== void 0 ? allPrevModuleIds : [])), GRID_NODE_TYPES.MODULE, tree, prevTree);
  const changedRootNodeChildren = !prevTree || !shallowEqual(prevTree.getRootNode().getChildNodeIds(), tree.getRootNode().getChildNodeIds());
  return {
    rootNode: tree.getRootNode().exportNode(),
    changedRootNodeChildren,
    addedSections,
    removedSections,
    changedSections,
    addedContainers,
    removedContainers,
    changedContainers,
    addedModules,
    removedModules,
    changedModules
  };
}
export function isDiffEmpty(diff) {
  return !diff.changedRootNodeChildren && diff.addedSections.length === 0 && diff.removedSections.length === 0 && diff.changedSections.length === 0 && diff.addedContainers.length === 0 && diff.removedContainers.length === 0 && diff.changedContainers.length === 0 && diff.addedModules.length === 0 && diff.removedModules.length === 0 && diff.changedModules.length === 0;
}
export function computeGridLayoutTreeMapDiff(currentGridLayoutTrees, prevGridLayoutTrees) {
  const result = {
    numberTreesChanged: 0,
    diffsByTreeId: {}
  };
  if (prevGridLayoutTrees === currentGridLayoutTrees) {
    return result;
  }
  result.numberTreesChanged = Math.abs(Object.keys(prevGridLayoutTrees).length - Object.keys(currentGridLayoutTrees).length);
  const currentGridLayoutTreesEntries = Object.entries(currentGridLayoutTrees);
  currentGridLayoutTreesEntries.forEach(([treeId, currentTree]) => {
    const diff = computeGridLayoutTreeDiff(currentTree, prevGridLayoutTrees[treeId]);
    result.diffsByTreeId[treeId] = diff;
  });
  return result;
}